import React from 'react';
import dialog from 'utils/dialog';
import { COMPANYSCALE } from '../../../regist/const/constant';

const getAllColumns = ({ csIndustryTree }) => [
  {
    name: 'enterprise_name',
    title: '服务商名称',
    render: (type, name, value) => (
      <div>
        <span>{value}</span>
      </div>
    ),
  },
  {
    name: 'staff_scale',
    title: '服务商规模',
    render: (type, name, value) => <div>{COMPANYSCALE[value]}</div>,
  },
  {
    name: 'core_service_industry',
    title: '主要服务行业',
    // render: (type, name, value) => <div>{value}</div>,
    render: (type, name, value) => (
      <div>{value?.map((val) => csIndustryTree.find((item) => item.value === val)?.label)}</div>
    ),
  },
];

// 参与状态
//   export const JOIN_STATUS_KV = {
//     1: '参与中',
//     2: '未参与',
//     3: '竞标中', // 已选中
//     4: '评标中',
//     5: '已中标', // 已中标
//     6: '未中标',
//   };

export default (props) => {
  const { viewAgencyDetail, toggleEnterStatue, toggleHitStatus, csIndustryTree, item } = props;
  const allColumns = getAllColumns({ csIndustryTree });

  return {
    emptyText: '暂无相关数据记录',
    hidePagination: true,
    columns: allColumns,
    operations: {
      maxWidth: 120,
      columnAction: (data) => {
        return [
          <div key="">
            {data.tender_status === 1 && (
              <span
                onClick={() => {
                  dialog
                    .confirm('确认加入竞标名单吗？')
                    .then(() => toggleEnterStatue(data, true))
                    .catch(() => {});
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                加入竞标名单
              </span>
            )}
            {data.tender_status === 3 && (
              <span
                onClick={() => {
                  dialog
                    .confirm('确认取消竞标名单吗？')
                    .then(() => toggleEnterStatue(data, false))
                    .catch(() => {});
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                取消竞标名单
              </span>
            )}

            {data.tender_status === 4 && ( // 评标中显示确认中标
              <span
                onClick={() => {
                  dialog
                    .confirm('确认中标吗？')
                    .then(() => toggleHitStatus(data, true))
                    .catch(() => {});
                }}
                style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
              >
                确认中标
              </span>
            )}
            {/* 已中标、已中标 && if_contract 1代表当前需求处于合同阶段 无需展示取消中标按钮 */}
            {data.tender_status === 5 &&
              data.if_contract !== 1 &&
              item?.status !== 4 && ( // 加入竞标名单后显示确认中标
                <span
                  onClick={() => {
                    dialog
                      .confirm('确认取消中标吗？')
                      .then(() => toggleHitStatus(data, false))
                      .catch(() => {});
                  }}
                  style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
                >
                  取消中标
                </span>
              )}
            <span
              onClick={() => {
                viewAgencyDetail(data);
              }}
              style={{ color: '#296bef', cursor: 'pointer', marginRight: '8px' }}
            >
              查看补充资料
            </span>
          </div>,
        ];
      },
    },
  };
};
